// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { SavantLogoProps } from './utils/types.ts'

function SavantLogo(props: SavantLogoProps) {
    const { width } = props

    const mainFontSize = width * 0.4
    const subFontSize = width * 0.2

    return (
        <>
            <svg
                x={-width / 2}
                y={0}
                width={width}
                height={width}
                viewBox="0 0 870 870"
            >
                <style>
                    {`.st0{fill:#FFFFFF;}
                    .st1{fill:#EF4C28;}
                    .st2{fill:#B4B4B5;}
                    .st3{fill:#489299;}`}
                </style>
                <circle className="st0" cx="430.67" cy="431.42" r="397.03" />
                <g>
                    <path
                        className="st1"
                        d="M702.07,165.14l-24.36,16.93l-5.5-44.43c0.18-0.2,0.3-0.46,0.54-0.66c10.67,9,21.92,19.73,29.22,26.89
			L702.07,165.14z"
                    />
                    <path
                        className="st1"
                        d="M608.58,218.87l-0.29-33.19c11.21-5.35,21.2-11.33,30.31-17.89l0.29,38.06L608.58,218.87z"
                    />
                    <path
                        className="st1"
                        d="M526.71,240.43l10.21-33.08c12.63-2.15,24.24-4.71,35.09-7.92l-10.53,33.89L526.71,240.43z"
                    />
                    <path
                        className="st1"
                        d="M479.64,244.99l0.14,0.14l-31.72,1.68l20.29-33.55c11.64-0.26,22.67-0.83,33.06-1.6l-20.1,33.12
			L479.64,244.99z"
                    />
                    <path
                        className="st1"
                        d="M375.03,243.14l23.96-32.04c10.18,0.73,19.91,1.22,29.39,1.66l-26.02,34.95L375.03,243.14z"
                    />
                    <path
                        className="st1"
                        d="M306.89,231.95l29.16-30.37c9.18,2.05,18.44,3.82,27.75,5.27l-29.37,30.61L306.89,231.95z"
                    />
                    <path
                        className="st1"
                        d="M245.64,208.97l29.84-25.14c8.07,2.91,16.2,5.58,24.38,8.11l-30.72,25.95L245.64,208.97z"
                    />
                    <path
                        className="st1"
                        d="M194.93,181.64l30.15-18.72c7.57,3.54,15.27,6.89,22.98,10.26l-32.96,20.42L194.93,181.64z"
                    />
                    <path
                        className="st1"
                        d="M150.3,151.93l29.16-12.59c7.21,4.03,14.54,7.94,21.87,11.81l-33.19,14.49L150.3,151.93z"
                    />
                    <path
                        className="st1"
                        d="M676.63,185.55l49.37,11.98c-10.11,7.55-20.57,14.61-31.38,21.24l-53.83-13.54L676.63,185.55z"
                    />
                    <path
                        className="st1"
                        d="M605.88,220.36l50.34,19.12c-12.25,5.79-24.81,10.98-37.62,15.68l-55.47-21.84L605.88,220.36z"
                    />
                    <path
                        className="st1"
                        d="M481.16,245.07l0.15-0.28l44.78-3.85l41.6,29.56c-13.87,3.23-27.99,5.98-42.05,7.97l-45.86-33.34
			L481.16,245.07z"
                    />
                    <path
                        className="st1"
                        d="M444.23,246.94l26.23,35.98c-7.36,0.2-14.64,0.16-21.9-0.08c-6.91-0.25-13.59-0.76-20.34-1.17l-24.59-34.79
			L444.23,246.94z"
                    />
                    <path
                        className="st1"
                        d="M372.39,245l23.38,33.59c-12.61-1.66-25.14-3.5-37.25-5.89l-22.9-33.9L372.39,245z"
                    />
                    <path
                        className="st1"
                        d="M305.92,231.84l18.05,32.66c-11.41-3.07-22.52-6.5-33.28-10.21l-18.13-33.96L305.92,231.84z"
                    />
                    <path
                        className="st1"
                        d="M243.31,208.2l11.37,32.37c-9.73-4.16-19.08-8.45-28.12-13.07l-11.25-33.38L243.31,208.2z"
                    />
                    <path
                        className="st1"
                        d="M192.42,181.16l5.4,30.92c-8.26-4.81-16.26-9.66-23.95-14.73l-5.23-31.17L192.42,181.16z"
                    />
                    <path
                        className="st1"
                        d="M206.77,744.94l0.23,0l-0.07,0.01l26.8-10.14l0.25,0.21l0.13-0.04l1.94,32.72
			c-8.9,3.27-17.82,5.74-26.84,7.65L206.77,744.94L206.77,744.94z"
                    />
                    <path
                        className="st1"
                        d="M285.59,702.62l1.57,39.27c-7.96,5.06-15.99,9.78-24.15,13.99l-1.53-36.31L285.59,702.62z"
                    />
                    <path
                        className="st1"
                        d="M327.37,664.81l6.22,42.16c-6.98,6.01-14.15,11.84-21.29,17.28l-5.75-38.76L327.37,664.81z"
                    />
                    <path
                        className="st1"
                        d="M365.89,623.21l11.72,42.28c-6.52,6.65-13.22,13.22-20.04,19.77l-11.15-39.78L365.89,623.21z"
                    />
                    <path
                        className="st1"
                        d="M440.77,533.15L454,581.91c-6.09,6.82-12.77,14.22-19.63,21.92l-13.31-48.78L440.77,533.15z"
                    />
                    <path
                        className="st1"
                        d="M480.8,496.46l11.71,47.75c-4.95,4.22-9.86,8.53-14.72,13.14c-2.07,1.94-4.42,4.19-6.64,6.5l-12.02-49.52
			L480.8,496.46z"
                    />
                    <path
                        className="st1"
                        d="M535.07,464.09l5.11,47.17c-9.15,4.93-18.04,10.68-26.84,16.97l-5.55-50.18L535.07,464.09z"
                    />
                    <path
                        className="st1"
                        d="M598.97,445.76l0.93,45.04c-10.57,1.85-20.86,4.28-30.71,7.76l-0.92-46.49L598.97,445.76z"
                    />
                    <path
                        className="st1"
                        d="M675.66,443.76l-10.93,47.71c-10.8-1.86-21.09-2.68-31.11-2.91l10.69-46.77L675.66,443.76z"
                    />
                    <path
                        className="st1"
                        d="M750.25,462.97l-23.47,47.14c-10.63-4.4-20.81-7.99-30.77-10.98l23.56-47.17L750.25,462.97z"
                    />
                    <path
                        className="st1"
                        d="M788.38,483.72l-0.23-0.37l24.78,15.68l-34.42,36.48c-9.43-5.25-18.49-10.04-27.39-14.46l35.93-38.04
			L788.38,483.72z"
                    />
                    <path
                        className="st1"
                        d="M402.33,578.22l14.5,45.27c-6.11,6.83-12.52,13.9-19.16,20.93l-13.85-43.51L402.33,578.22z"
                    />
                    <path
                        className="st1"
                        d="M206.77,744.94l-32.59,2.46l-45.67-40.36c9.91,1.23,20.4,2.13,31.21,2.35c2.7-0.01,5.29-0.3,7.88-0.44
			l39.32,35.99L206.77,744.94z"
                    />
                    <path
                        className="st1"
                        d="M234.11,734.97l0.01-0.26l-0.39,0.1l-41.28-29.88c10.07-2.97,20.03-7.39,29.8-12.86l38.76,28.36
			L234.11,734.97z"
                    />
                    <path
                        className="st1"
                        d="M327.3,664.73l-42.99-22.11c6.39-6.36,12.64-13.12,18.84-19.9l43.22,22.2L327.3,664.73z"
                    />
                    <path
                        className="st1"
                        d="M285.6,702.52l-39.64-26.06c7.18-5.43,14.37-11.21,21.36-17.54l39.38,25.88L285.6,702.52z"
                    />
                    <path
                        className="st1"
                        d="M365.33,623.03l-45.4-19.31c5.96-6.96,11.87-13.99,17.78-21.11l45.41,19.3L365.33,623.03z"
                    />
                    <path
                        className="st1"
                        d="M402.51,576.83l-43.53-20.07c5.86-7.19,11.58-14.17,17.29-21.09l44.5,20.59L402.51,576.83z"
                    />
                    <path
                        className="st1"
                        d="M439.41,532.45l-40.2-23.33c6.26-6.92,12.51-13.38,18.96-19.59l41.47,24.05L439.41,532.45z"
                    />
                    <path
                        className="st1"
                        d="M480.56,496.04l-43.84-23.19c7.51-6.35,15.17-12.27,22.97-17.8l46.49,24.37L480.56,496.04z"
                    />
                    <path
                        className="st1"
                        d="M535.09,463.92l-34.96-33.78c9.25-4.83,18.45-9.09,27.76-12.86l35.62,34.87L535.09,463.92z"
                    />
                    <path
                        className="st1"
                        d="M602.33,444.16l-38.06-38.75c12.08-3.09,24.2-5.47,36.23-6.93l41.84,43.12L602.33,444.16z"
                    />
                    <path
                        className="st1"
                        d="M677.64,443.7l-35.48-47.17c12.77,0.32,25.22,1.63,37.58,3.75l38.54,52.04L677.64,443.7z"
                    />
                    <path
                        className="st1"
                        d="M787.26,482.76l-0.21,0.25l-36.09-20.37l-20.18-48.11c12.74,5.17,24.9,11.27,36.54,18.39l20.83,50.44
			L787.26,482.76z"
                    />
                </g>
                <path
                    className="st2"
                    d="M849.08,404.16l-0.41-6.4l-53.12,3.41l0.41,6.4c0.51,7.89,0.76,15.91,0.76,23.85
		c0,45.56-8.17,89.76-24.28,131.4c-43.2,113-139.99,197.2-258.92,225.24l-6.22,1.47l12,51.86l6.27-1.48
		c136.2-32.11,247.06-128.56,296.54-257.98c18.47-47.72,27.83-98.36,27.83-150.51C849.95,422.31,849.66,413.14,849.08,404.16z"
                />
                <path
                    className="st1"
                    d="M848.11,404.22L848.11,404.22c-5.29-82.65-35.06-161.26-86.08-227.35c-50-64.75-116.97-113.27-193.68-140.32
		l-5.15-1.82l-16.96,48.41l5.13,1.81c67.32,23.74,126.12,66.36,170.06,123.27c44.75,57.95,70.86,126.87,75.49,199.28l0.35,5.44
		l51.19-3.29L848.11,404.22z"
                />
                <path
                    className="st3"
                    d="M568.49,36.09c-44.71-15.57-91.08-23.47-137.83-23.47c-230.93,0-418.8,187.87-418.8,418.8
		c0,230.93,187.87,418.8,418.8,418.8c30.94,0,63.7-3.73,94.75-10.77l5.81-1.32l-11.78-50.92l-5.76,1.31
		c-27.19,6.17-55.9,9.44-83.01,9.44c-202.11,0-366.54-164.43-366.54-366.54c0-202.11,164.43-366.54,366.54-366.54
		c40.88,0,81.44,6.91,120.56,20.53l5.59,1.95l17.29-49.32L568.49,36.09z"
                />
            </svg>
            <text
                x={0}
                y={width}
                className="comp-tool-logo-text comp-tool-logo-main-text"
                style={{
                    fontSize: `${mainFontSize}px`,
                    fontFamily: 'Roboto Condensed',
                }}
            >
                savant
            </text>
            <text
                x={0}
                y={(width * 7) / 5}
                className="comp-tool-logo-text comp-tool-logo-sub-text"
                style={{
                    fontSize: `${subFontSize}px`,
                    fontFamily: 'Roboto Condensed',
                }}
            >
                Player Comparison Tool
            </text>
        </>
    )
}

export default SavantLogo
